function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import { CssContainer } from "../../components/container";
import { Link } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import { Pill, Empty, Search, Pending } from "../../components/analytics-kit";
import { Loader } from "../../components/loaders";
import Error from "../../components/error";
import ServiceFactory from "../../service";
import { RANGES, num, usd, rangeLabelFor } from "../sales/territory-common";
import { fetchAudienceApi, mmss } from "./index";
import AudienceTrendChart, { fetchTrends, rangeWindow } from "./trend-chart";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";
import { getMembers, addMembers, removeMembers, importMembers, exportMembers, getLinks, upsertLink, syncLinkNow, deleteLink, refreshAudience, getListHealth, getSummary, bulkMembers, membersFromList, membersFromRule, snapshotAudience, isSoft, toast } from "./api";
import { Modal, Check, ErrorLine, InlineConfirm, Menu, Banner, GrowthBars, downloadRowsCsv, fmtDateTime, fmtDate, RAIL_LABELS } from "./ui";
import RuleBuilder, { describeRule, emptyGroup, toRuleJson, validateRule } from "./rule-builder";
import ListEditor from "./list-editor";
import { hasTenantFeature, campaignsDashboardOnly } from "../../functions/tenant-features";

/*
 * One audience (redesign 2026-10-09, PlunkDocs mockups/audiences-redesign-2026-10-09.html board 2).
 * Layout: sub-page header (back, name, "N people · fills itself", Export, more menu) then two columns:
 *   left  People card (search, Everyone / Can get email / Can't email pills, ticked-row action bar, paging),
 *         then the collapsible Connected tools and History sections (the old Sync and History tabs)
 *   right How people get in (rule sentence, nightly update line, joined/left), the range numbers, Use this list
 * Data (unchanged from BULK_EMAIL_MANAGEMENT §7):
 *   Summary  GET /{id}/summary?range=30 → {members, withEmail, optedIn, optedOut, noConsent, inactive, suppressed,
 *            addedInRange, removedInRange, growthByWeek[], lastRefresh, kind, rule}  (soft-fails → health/total)
 *   Members  GET /v1/audience/{id}/members?q&$top&$skip (items carry lifecycleStage, lastActivityDate, consent, suppressed, company)
 *            The member read has no consent filter, so the pills filter the loaded page client-side.
 *            POST|DELETE members · POST members/bulk {action: copy|move|remove|suppress} · members/from-list · members/from-rule · import · export
 *   Rule     ListEditor (edit) · POST /{id}/refresh · POST /{id}/snapshot {name} · static: POST /{id}/convert
 *   Tools    GET|POST /{id}/links · links/{rail}/sync-now · DELETE links/{rail}
 *   History  GET /v1/audience/stats/{range}/{id}, /v1/sales/audiences/{range}, POST trends, GET /{id}/health
 * Ids are 19-digit strings end to end (api.js reviver; the route param is already a string).
 */

const SYSTEM_NAMES = ["All Contacts", "Customers", "Inactive", "Suppressed"];
const PAGE = 50;
const RAILS = ["mailchimp", "constant_contact"]; // Smartlead retired 2026-10-03 (own outreach rail instead)
const MODE_LABELS = {
  push: "Send from Plunk to the tool",
  pull: "Bring the tool's list into Plunk",
  two_way: "Both ways"
};
const FILTERS = [["all", "Everyone"], ["can", "Can get email"], ["cant", "Can't email"]];
function consentOf(m) {
  if (m.consent) return m.consent;
  if (m.emailOptIn === true) return "opted_in";
  if (m.emailOptIn === false) return "opted_out";
  return "none";
}
const cantEmail = m => !!m.suppressed || consentOf(m) === "opted_out" || !m.email;
const timeOf = v => {
  const d = new Date(v);
  return isNaN(d) ? "" : d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit"
  });
};
function lastRunText(v) {
  if (!v) return "";
  const d = new Date(v);
  if (isNaN(d)) return "";
  return d.toDateString() === new Date().toDateString() ? `last at ${timeOf(v)}` : `last on ${fmtDate(v)} at ${timeOf(v)}`;
}
function latestText(v) {
  if (!v) return "";
  const d = new Date(v);
  if (isNaN(d)) return "";
  const days = Math.floor((Date.now() - d.getTime()) / 86400000);
  if (d.toDateString() === new Date().toDateString()) return "Active today";
  if (days <= 1) return "Active yesterday";
  return `Active ${fmtDate(v)}`;
}
class AudienceDetailViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onSearch", q => {
      this.setState({
        q
      });
      clearTimeout(this._debounce);
      this._debounce = setTimeout(() => this.loadMembers(0), 350);
    });
    _defineProperty(this, "closeDialog", () => this.setState({
      dialog: null,
      err: "",
      importPreview: null,
      importResult: null,
      importFile: null,
      rulePreview: null
    }));
    _defineProperty(this, "toggle", m => this.setState(s => {
      const selected = {
        ...s.selected
      };
      const k = String(m.personId);
      if (selected[k]) delete selected[k];else selected[k] = true;
      return {
        selected
      };
    }));
    _defineProperty(this, "toggleAll", () => {
      const page = this.visibleMembers().map(m => String(m.personId));
      this.setState(s => {
        const all = page.length && page.every(k => s.selected[k]);
        const selected = {
          ...s.selected
        };
        page.forEach(k => {
          if (all) delete selected[k];else selected[k] = true;
        });
        return {
          selected
        };
      });
    });
    _defineProperty(this, "addByEmails", async () => {
      const emails = this.state.addText.split(/[\s,;]+/).map(s => s.trim()).filter(Boolean);
      if (!emails.length) {
        this.setState({
          err: "Paste at least one address."
        });
        return;
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const r = await addMembers(this.id(), {
          emails
        });
        toast(`${num(r.changed)} added. ${num(r.resolved)} of ${num(r.requested)} were already in your contacts${r.unresolved && r.unresolved.length ? `, ${r.unresolved.length} were not found` : ""}.`);
        this.setState({
          dialog: null,
          addText: ""
        });
        this.refreshAll();
      } catch (e) {
        this.setState({
          err: e.message || "Could not add them."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "addFromList", async () => {
      const {
        fromListId,
        fromListMode
      } = this.state;
      if (!fromListId) {
        this.setState({
          err: "Pick a list to copy from."
        });
        return;
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const r = await membersFromList(this.id(), {
          sourceAudienceId: String(fromListId),
          mode: fromListMode
        });
        toast(`${num(r && r.added)} added${r && r.skipped != null ? `. ${num(r.skipped)} skipped (already here, blocked from email or no address)` : ""}.`);
        this.setState({
          dialog: null
        });
        this.refreshAll();
      } catch (e) {
        this.setState({
          err: isSoft(e) ? "Copying from another list is not turned on for your account yet." : e.message || "Could not add them."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "previewRule", ruleJson => membersFromRule(this.id(), {
      ruleJson,
      preview: true
    }));
    _defineProperty(this, "addFromRule", async () => {
      const v = validateRule(this.state.ruleTree);
      if (v) {
        this.setState({
          err: v
        });
        return;
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const r = await membersFromRule(this.id(), {
          ruleJson: toRuleJson(this.state.ruleTree),
          preview: false
        });
        toast(`${num(r && r.added)} added.`);
        this.setState({
          dialog: null,
          rulePreview: null
        });
        this.refreshAll();
      } catch (e) {
        this.setState({
          err: isSoft(e) ? "Adding people with a filter is not turned on for your account yet." : e.message || "Could not add them."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "bulk", async action => {
      const personIds = Object.keys(this.state.selected);
      if (!personIds.length) return;
      this.setState({
        busy: true,
        err: ""
      });
      try {
        let r;
        const body = {
          action,
          personIds
        };
        if (action === "copy" || action === "move") {
          if (!this.state.targetId) {
            this.setState({
              err: "Pick a list.",
              busy: false
            });
            return;
          }
          body.targetAudienceId = String(this.state.targetId);
        }
        if (action === "suppress") body.reason = "manual";
        try {
          r = await bulkMembers(this.id(), body);
        } catch (e) {
          if (action === "remove" && isSoft(e)) {
            const x = await removeMembers(this.id(), {
              personIds
            });
            r = {
              removed: x && x.changed
            };
          } else throw e;
        }
        const target = (this.state.data.all || []).find(x => String(x.id) === String(this.state.targetId));
        const tn = target ? target.name : "the list";
        const msg = action === "copy" ? `${num(r && r.added)} copied to “${tn}”.` : action === "move" ? `${num(r && r.added)} moved to “${tn}”.` : action === "remove" ? `${num(r && r.removed)} removed from this list. They stay in your contacts.` : `${num(r && r.suppressed)} will no longer get bulk email from any list.`;
        toast(msg);
        this.setState({
          selected: {},
          dialog: null,
          bulkConfirm: null,
          note: msg
        });
        this.refreshAll();
      } catch (e) {
        const m = isSoft(e) ? "This action is not turned on for your account yet." : e.message || "That did not work.";
        if (this.state.dialog) this.setState({
          err: m
        });else toast(m);
        this.setState({
          bulkConfirm: null
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "exportSelected", () => {
      const {
        members,
        selected,
        data
      } = this.state;
      const rows = (members || []).filter(m => selected[String(m.personId)]);
      if (!rows.length) {
        toast("Tick people on this page first.");
        return;
      }
      downloadRowsCsv([["personId", "firstName", "lastName", "email", "phone", "company", "lifecycleStage", "consent", "lastActivityDate", "addedDate", "addedSource", "suppressed"], ...rows.map(m => [String(m.personId), m.firstName, m.lastName, m.email, m.phone, m.company, m.lifecycleStage, consentOf(m), m.lastActivityDate, m.addedDate, m.addedSource || m.source, m.suppressed ? "yes" : "no"])], `${(data.a.name || "audience").replace(/[^\w\- ]+/g, "").trim().replace(/ /g, "-")}-selected.csv`);
    });
    _defineProperty(this, "export", async () => {
      try {
        await exportMembers(this.id(), this.state.data.a.name);
      } catch (e) {
        toast(e.message || "Export did not work.");
      }
    });
    // ── import ─────────────────────────────────────────────────────────
    _defineProperty(this, "runImport", async mode => {
      if (!this.state.importFile) {
        this.setState({
          err: "Choose a CSV file."
        });
        return;
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const r = await importMembers(this.id(), this.state.importFile, mode, this.state.applySuggestions);
        if (!this._alive) return;
        if (mode === "preview") this.setState({
          importPreview: r
        });else {
          this.setState({
            importResult: r
          });
          toast("People added from the file.");
          this.refreshAll();
        }
      } catch (e) {
        const headers = e.data && e.data.headers;
        if (this._alive) this.setState({
          err: (e.message || "The file could not be read.") + (headers ? `. Columns found: ${headers.join(", ")}` : "")
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    // ── list actions ───────────────────────────────────────────────────
    _defineProperty(this, "refreshNow", async () => {
      this.setState({
        busy: true
      });
      try {
        const r = await refreshAudience(this.id());
        const note = r && r.queued ? "Update started. The count changes when it finishes." : r && r.total !== undefined ? `Updated: ${num(r.total)} people (${num(r.added)} joined, ${num(r.removed)} left).` : "Updated.";
        toast(note);
        this.setState({
          note
        });
        this.load();
      } catch (e) {
        toast(e.message || "Update did not work.");
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "snapshot", async () => {
      const name = this.state.snapName.trim();
      if (!name) {
        this.setState({
          err: "Give the copy a name."
        });
        return;
      }
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const r = await snapshotAudience(this.id(), name);
        toast(`“${r && r.name || name}” created.`);
        this.setState({
          dialog: null
        });
        if (r && r.id !== undefined) this.props.history.push(`/Audiences/Detail/${encodeURIComponent(String(r.id))}/${this.range()}`);
      } catch (e) {
        this.setState({
          err: isSoft(e) ? "Copies are not turned on for your account yet." : e.message || "Could not make the copy."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "removeList", async () => {
      const a = this.state.data.a;
      this.setState({
        busy: true,
        err: ""
      });
      try {
        const Service = ServiceFactory.getType("/audience", "audience");
        await new Service().deleteAsync(String(a.id));
        toast(`“${a.name}” removed. The people stay in your contacts.`);
        this.props.history.push("/Audiences");
      } catch (e) {
        this.setState({
          err: e.message || "Could not remove the list."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    // ── connected tools ────────────────────────────────────────────────
    _defineProperty(this, "openLink", () => this.setState({
      dialog: "link",
      linkRail: "mailchimp",
      linkMode: "push",
      linkTarget: "",
      err: "",
      openTools: true
    }));
    _defineProperty(this, "saveLink", async () => {
      this.setState({
        busy: true,
        err: ""
      });
      try {
        await upsertLink(this.id(), {
          rail: this.state.linkRail,
          syncMode: this.state.linkMode,
          externalListId: this.state.linkTarget || undefined
        });
        toast(`${RAIL_LABELS[this.state.linkRail]} connected.`);
        this.setState({
          dialog: null,
          linkTarget: ""
        });
        this.loadLinks();
      } catch (e) {
        this.setState({
          err: e.message || "Could not connect."
        });
      } finally {
        if (this._alive) this.setState({
          busy: false
        });
      }
    });
    _defineProperty(this, "syncNow", async rail => {
      try {
        const r = await syncLinkNow(this.id(), rail);
        toast(r && r.note || "Update requested.");
        this.loadLinks();
      } catch (e) {
        toast(e.message || "Update request did not work.");
      }
    });
    _defineProperty(this, "unlink", async rail => {
      try {
        await deleteLink(this.id(), rail);
        toast(`${RAIL_LABELS[rail] || rail} disconnected.`);
        this.setState({
          unlinking: null
        });
        this.loadLinks();
      } catch (e) {
        toast(e.message || "Could not disconnect.");
      }
    });
    this.state = {
      data: null,
      error: false,
      trend: undefined,
      health: undefined,
      summary: undefined,
      // people
      members: undefined,
      memberCount: 0,
      skip: 0,
      q: "",
      filter: "all",
      selected: {},
      busy: false,
      err: "",
      dialog: null,
      // "email" | "import" | "fromList" | "fromRule" | "copy" | "move" | "link" | "edit" | "convert" | "snapshot" | "remove"
      bulkConfirm: null,
      // "remove" | "suppress"
      addText: "",
      fromListId: "",
      fromListMode: "not_in_target",
      ruleTree: emptyGroup(),
      rulePreview: null,
      targetId: "",
      snapName: "",
      // import
      importFile: null,
      importPreview: null,
      applySuggestions: false,
      importResult: null,
      // connected tools
      links: undefined,
      linkRail: "mailchimp",
      linkMode: "push",
      linkTarget: "",
      unlinking: null,
      openTools: false,
      openHistory: false,
      note: ""
    };
    this._alive = true;
    this._debounce = null;
  }
  range() {
    const r = this.props.params && this.props.params.range;
    return r && RANGES.some(x => x[0] === r) ? r : getGlobalRange();
  }
  id() {
    return decodeURIComponent(this.props.params && this.props.params.id || "");
  }
  componentDidMount() {
    this.load();
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range) return;
      const target = `/Audiences/Detail/${encodeURIComponent(this.id())}/${range}`;
      if (window.location.pathname === target) {
        this.load();
      } else {
        this.props.history.push(target);
      }
    });
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
    clearTimeout(this._debounce);
  }
  componentDidUpdate(prev) {
    const prevKey = `${prev.params && prev.params.range || ""}|${prev.params && prev.params.id || ""}`;
    const curKey = `${this.props.params && this.props.params.range || ""}|${this.props.params && this.props.params.id || ""}`;
    if (prevKey !== curKey) {
      this.setState({
        data: null,
        error: false,
        members: undefined,
        trend: undefined,
        links: undefined,
        health: undefined,
        summary: undefined,
        selected: {}
      });
      this.load();
    }
  }
  async load() {
    const range = this.range();
    const id = this.id();
    try {
      const [audiences, stats, sales] = await Promise.all([fetchAudienceApi("/audience"), fetchAudienceApi(`/audience/stats/${range}/${id}`, "product").catch(() => null), fetchAudienceApi(`/sales/audiences/${range}`, "product").catch(() => [])]);
      if (!this._alive) return;
      const rows = Array.isArray(audiences) ? audiences : audiences.items || [];
      const a = rows.find(x => String(x.id) === id) || null;
      if (a && rangeWindow(range)) {
        fetchTrends(range, [a.name]).then(t => {
          if (this._alive) this.setState({
            trend: t
          });
        }).catch(() => {
          if (this._alive) this.setState({
            trend: null
          });
        });
      } else {
        this.setState({
          trend: null
        });
      }
      const sl = (sales || []).find(s => String(s.audienceId) === id) || null;
      this.setState({
        data: {
          a,
          stats,
          sl,
          all: rows
        }
      });
      if (a) {
        this.loadMembers(0);
        this.loadLinks();
        this.loadSummary();
        getListHealth(id, 30).then(h => {
          if (this._alive) this.setState({
            health: h
          });
        }).catch(() => {
          if (this._alive) this.setState({
            health: null
          });
        });
      }
    } catch (e) {
      if (this._alive) this.setState({
        error: true
      });
    }
  }
  async loadSummary() {
    try {
      const s = await getSummary(this.id(), 30);
      if (this._alive) this.setState({
        summary: s || null
      });
    } catch (e) {
      if (this._alive) this.setState({
        summary: null
      });
    }
  }
  async loadMembers(skip = 0) {
    this.setState({
      members: undefined,
      skip
    });
    try {
      const r = await getMembers(this.id(), this.state.q || undefined, PAGE, skip);
      if (!this._alive) return;
      this.setState({
        members: r && r.items || [],
        memberCount: Number(r && r.count) || 0
      });
    } catch (e) {
      if (this._alive) this.setState({
        members: null
      });
    }
  }
  async loadLinks() {
    try {
      const r = await getLinks(this.id());
      if (this._alive) this.setState({
        links: r && r.items || []
      });
    } catch (e) {
      if (this._alive) this.setState({
        links: null
      });
    }
  }
  refreshAll() {
    this.loadMembers(this.state.skip);
    this.load();
  }
  // ── people ─────────────────────────────────────────────────────────
  visibleMembers() {
    const {
      members,
      filter
    } = this.state;
    const page = members || [];
    if (filter === "can") return page.filter(m => !cantEmail(m));
    if (filter === "cant") return page.filter(cantEmail);
    return page;
  }
  // ── renders ────────────────────────────────────────────────────────
  renderHeader(a, isProtected, isDynamic, count) {
    const how = isProtected ? "kept up to date by Plunk" : isDynamic ? "fills itself" : "people you add";
    const more = [!isProtected ? {
      label: "Rename or describe",
      onClick: () => this.setState({
        dialog: "edit",
        err: ""
      })
    } : null, {
      label: "Make a copy",
      hint: "a new list with today's people",
      onClick: () => this.setState({
        dialog: "snapshot",
        snapName: `${a.name} (copy)`,
        err: ""
      })
    }, !isProtected && !isDynamic ? {
      label: "Turn into a list that fills itself",
      hint: "describe who belongs instead",
      onClick: () => this.setState({
        dialog: "convert",
        err: ""
      })
    } : null, !isProtected ? {
      label: "Remove",
      onClick: () => this.setState({
        dialog: "remove",
        err: ""
      })
    } : null];
    return /*#__PURE__*/React.createElement("header", {
      className: "ad-head"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Audiences",
      className: "ad-back",
      "aria-label": "Back to Audiences"
    }, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M15 18l-6-6 6-6"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "ad-title"
    }, /*#__PURE__*/React.createElement("h1", null, a.name), /*#__PURE__*/React.createElement("span", {
      className: "ad-sub"
    }, num(count), " ", Number(count) === 1 ? "person" : "people", " \xB7 ", how, a.status && a.status !== "Active" ? ` · ${String(a.status).toLowerCase()}` : ""), a.description ? /*#__PURE__*/React.createElement("span", {
      className: "ad-desc"
    }, a.description) : null), /*#__PURE__*/React.createElement("span", {
      className: "ad-head-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.export
    }, "Export"), /*#__PURE__*/React.createElement(Menu, {
      label: "\xB7\xB7\xB7",
      items: more
    })));
  }
  renderPeople(a, isDynamic, isProtected) {
    const {
      members,
      memberCount,
      skip,
      q,
      filter,
      selected,
      busy,
      bulkConfirm,
      data
    } = this.state;
    const nSel = Object.keys(selected).length;
    const rows = this.visibleMembers();
    const allOn = rows.length > 0 && rows.every(m => selected[String(m.personId)]);
    const otherLists = (data.all || []).filter(l => String(l.id) !== this.id() && l.kind !== "dynamic" && l.kind !== "system" && !SYSTEM_NAMES.includes(l.name));
    return /*#__PURE__*/React.createElement("section", {
      className: "ad-card ad-people"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ad-people-head"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ad-card-title"
    }, "People"), /*#__PURE__*/React.createElement("span", {
      className: "ad-muted"
    }, members !== undefined && members !== null ? num(memberCount) : ""), /*#__PURE__*/React.createElement("span", {
      className: "ad-grow"
    }), /*#__PURE__*/React.createElement(Search, {
      value: q,
      onChange: this.onSearch,
      placeholder: "Search name or email"
    }), /*#__PURE__*/React.createElement("span", {
      className: "ad-pills",
      role: "group",
      "aria-label": "Show"
    }, FILTERS.map(([k, l]) => /*#__PURE__*/React.createElement("button", {
      key: k,
      type: "button",
      className: `ad-pill${filter === k ? " on" : ""}`,
      "aria-pressed": filter === k,
      onClick: () => this.setState({
        filter: k
      })
    }, l))), !isDynamic ? this.renderAddMenu() : null), nSel ? /*#__PURE__*/React.createElement("div", {
      className: "ad-bulkbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "cnt"
    }, num(nSel), " ticked"), bulkConfirm === "remove" ? /*#__PURE__*/React.createElement(InlineConfirm, {
      question: `Remove ${num(nSel)} from this list? They stay in your contacts.`,
      yes: "Yes, remove",
      busy: busy,
      onYes: () => this.bulk("remove"),
      onNo: () => this.setState({
        bulkConfirm: null
      })
    }) : bulkConfirm === "suppress" ? /*#__PURE__*/React.createElement(InlineConfirm, {
      question: `Stop emailing ${num(nSel)}? They will not get bulk email from any list.`,
      yes: "Yes, stop emailing",
      busy: busy,
      onYes: () => this.bulk("suppress"),
      onNo: () => this.setState({
        bulkConfirm: null
      })
    }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      disabled: busy || !otherLists.length,
      onClick: () => this.setState({
        dialog: "copy",
        targetId: "",
        err: ""
      })
    }, "Copy to list"), !isDynamic ? /*#__PURE__*/React.createElement(Button, {
      disabled: busy || !otherLists.length,
      onClick: () => this.setState({
        dialog: "move",
        targetId: "",
        err: ""
      })
    }, "Move to list") : null, /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: this.exportSelected
    }, "Export selected"), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setState({
        bulkConfirm: "suppress"
      })
    }, "Stop emailing"), !isDynamic ? /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setState({
        bulkConfirm: "remove"
      })
    }, "Remove") : null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "ad-link ad-right",
      onClick: e => {
        e.preventDefault();
        this.setState({
          selected: {}
        });
      }
    }, "Clear"))) : null, members === undefined ? /*#__PURE__*/React.createElement(Pending, null) : members === null ? /*#__PURE__*/React.createElement(Empty, null, "People could not be loaded right now. Try again in a moment.") : members.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, q ? "No one matches that search." : isDynamic ? "No one matches yet. Change who's in, then press Update now." : isProtected ? "No one here yet." : "No one here yet. Use Add people to paste addresses, upload a file or copy another list.") : rows.length === 0 ? /*#__PURE__*/React.createElement(Empty, null, "No one on this page ", filter === "can" ? "can get email" : "is blocked from email", ". Try the next page or Everyone.") : /*#__PURE__*/React.createElement("div", {
      className: "ad-tablewrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "ad-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
      className: "ad-sel"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      "aria-label": "Tick everyone shown",
      checked: allOn,
      onChange: this.toggleAll
    })), /*#__PURE__*/React.createElement("th", null, "Name"), /*#__PURE__*/React.createElement("th", null, "Email"), /*#__PURE__*/React.createElement("th", null, "Email permission"), /*#__PURE__*/React.createElement("th", null, "Latest"), /*#__PURE__*/React.createElement("th", null, "Joined"))), /*#__PURE__*/React.createElement("tbody", null, rows.map(m => {
      const k = String(m.personId);
      const c = consentOf(m);
      const perm = m.suppressed || c === "opted_out" ? /*#__PURE__*/React.createElement("span", {
        className: "ad-chip bad"
      }, "Can't email") : c === "opted_in" ? /*#__PURE__*/React.createElement("span", {
        className: "ad-chip ok"
      }, "Opted in") : null;
      return /*#__PURE__*/React.createElement("tr", {
        key: k,
        className: selected[k] ? "on" : ""
      }, /*#__PURE__*/React.createElement("td", {
        className: "ad-sel"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        "aria-label": "Tick",
        checked: !!selected[k],
        onChange: () => this.toggle(m)
      })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
        className: "ad-name",
        to: `/Contacts/Detail/${encodeURIComponent(k)}`
      }, [m.firstName, m.lastName].filter(Boolean).join(" ") || m.email || "(no name)"), m.company ? /*#__PURE__*/React.createElement("span", {
        className: "ad-co"
      }, m.company) : null), /*#__PURE__*/React.createElement("td", {
        className: "ad-muted ad-email"
      }, m.email || ""), /*#__PURE__*/React.createElement("td", null, perm), /*#__PURE__*/React.createElement("td", {
        className: "ad-muted"
      }, latestText(m.lastActivityDate)), /*#__PURE__*/React.createElement("td", {
        className: "ad-muted"
      }, m.addedDate ? fmtDate(m.addedDate) : ""));
    })))), /*#__PURE__*/React.createElement("div", {
      className: "ad-people-foot"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ad-muted"
    }, "Tick people to copy, ", !isDynamic ? "move, " : "", "export or stop emailing them.", members && members.length ? ` Showing ${num(skip + 1)} to ${num(Math.min(skip + PAGE, memberCount))} of ${num(memberCount)}.` : "", filter !== "all" && members && members.length ? " Filters apply to this page." : ""), memberCount > PAGE ? /*#__PURE__*/React.createElement("span", {
      className: "ad-pager"
    }, /*#__PURE__*/React.createElement(Button, {
      disabled: skip === 0,
      onClick: () => this.loadMembers(Math.max(0, skip - PAGE))
    }, "Previous"), /*#__PURE__*/React.createElement(Button, {
      disabled: skip + PAGE >= memberCount,
      onClick: () => this.loadMembers(skip + PAGE)
    }, "Next")) : null));
  }
  renderAddMenu() {
    return /*#__PURE__*/React.createElement(Menu, {
      label: "Add people",
      primary: true,
      items: [{
        label: "Paste email addresses",
        hint: "people already in your contacts",
        onClick: () => this.setState({
          dialog: "email",
          err: ""
        })
      }, {
        label: "Upload a file",
        hint: "a CSV of new or known people",
        onClick: () => this.setState({
          dialog: "import",
          importPreview: null,
          importResult: null,
          importFile: null,
          err: ""
        })
      }, {
        label: "Copy from another list",
        onClick: () => this.setState({
          dialog: "fromList",
          fromListId: "",
          err: ""
        })
      }, {
        label: "Pick people with a filter",
        hint: "see who matches before adding",
        onClick: () => this.setState({
          dialog: "fromRule",
          ruleTree: emptyGroup(),
          rulePreview: null,
          err: ""
        })
      }]
    });
  }
  renderHowCard(a, isDynamic, isProtected) {
    const {
      summary: s,
      busy,
      data
    } = this.state;
    const ruleJson = a.ruleJson || s && s.rule;
    const sentence = isDynamic && ruleJson ? describeRule(ruleJson, data.all) : null;
    const last = lastRunText(s && s.lastRefresh || a.ruleRefreshed || a.lastRefreshDate);
    const moved = s && (s.addedInRange != null || s.removedInRange != null) ? `+${num(s.addedInRange)} joined and ${num(s.removedInRange)} left in the last 30 days.` : "";
    return /*#__PURE__*/React.createElement("section", {
      className: "ad-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ad-card-title"
    }, "How people get in"), isDynamic ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "ad-rule"
    }, sentence || /*#__PURE__*/React.createElement("span", {
      className: "ad-muted"
    }, "Nothing describes who belongs yet. Press Change who's in to set it up.")), /*#__PURE__*/React.createElement("p", {
      className: "ad-small"
    }, "Updated every night", last ? `, ${last}` : "", ".", moved ? ` ${moved}` : ""), !isProtected ? /*#__PURE__*/React.createElement("div", {
      className: "ad-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        dialog: "edit",
        err: ""
      })
    }, "Change who's in"), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: this.refreshNow
    }, busy ? "Updating…" : "Update now")) : null) : isProtected ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "ad-rule"
    }, "Plunk keeps this list up to date for you."), moved ? /*#__PURE__*/React.createElement("p", {
      className: "ad-small"
    }, moved) : null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
      className: "ad-rule"
    }, "People you add: imports, forms and the API."), moved ? /*#__PURE__*/React.createElement("p", {
      className: "ad-small"
    }, moved) : null, /*#__PURE__*/React.createElement("div", {
      className: "ad-actions"
    }, this.renderAddMenu())));
  }
  renderNumbersCard(st, sl) {
    const {
      summary: s,
      health: h
    } = this.state;
    const members = s ? Number(s.members) : h ? Number(h.members) : null;
    const withEmail = s ? s.withEmail : h ? h.withEmail : null;
    const tiles = [];
    if (withEmail != null && members > 0) tiles.push([`${Math.round(Number(withEmail) / members * 100)}%`, "can get email"]);
    if (st && st.sessions != null) tiles.push([num(st.sessions), "site visits"]);
    if (sl && sl.orders != null) tiles.push([num(sl.orders), "orders"]);
    if (sl && sl.totalAmount != null) tiles.push([usd(sl.totalAmount), "in sales"]);
    if (!tiles.length) return null;
    const range = this.range();
    return /*#__PURE__*/React.createElement("section", {
      className: "ad-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ad-card-title"
    }, rangeLabelFor(range, RANGES)), /*#__PURE__*/React.createElement("div", {
      className: "ad-nums"
    }, tiles.map(([v, l]) => /*#__PURE__*/React.createElement("span", {
      key: l,
      className: "ad-num"
    }, /*#__PURE__*/React.createElement("b", null, v), /*#__PURE__*/React.createElement("span", null, l)))));
  }
  renderUseCard(a) {
    const {
      links
    } = this.state;
    const connected = (links || []).map(l => RAIL_LABELS[l.rail] || l.rail);
    return /*#__PURE__*/React.createElement("section", {
      className: "ad-card"
    }, /*#__PURE__*/React.createElement("b", {
      className: "ad-card-title"
    }, "Use this list"), /*#__PURE__*/React.createElement(Link, {
      className: "ad-uselink",
      to: `/Email/campaigns/new?audience=${encodeURIComponent(String(a.id))}`
    }, "Send an email to these people"), hasTenantFeature("campaigns") && !campaignsDashboardOnly() ? /*#__PURE__*/React.createElement(Link, {
      className: "ad-uselink",
      to: `/Campaigns/NewFlight?audience=${encodeURIComponent(String(a.id))}&name=${encodeURIComponent(a.name || "")}`
    }, "Show ads to these people") : null, /*#__PURE__*/React.createElement("a", {
      href: "#",
      className: "ad-uselink",
      onClick: e => {
        e.preventDefault();
        this.openLink();
      }
    }, "Keep a copy in another tool"), connected.length ? /*#__PURE__*/React.createElement("span", {
      className: "ad-small"
    }, "Copies kept in ", connected.join(" and "), ".") : null);
  }
  renderTools() {
    const {
      links,
      health,
      unlinking,
      openTools
    } = this.state;
    const notSent = health ? Math.max(0, Number(health.members) - Number(health.deliverable)) : null;
    return /*#__PURE__*/React.createElement("details", {
      className: "ad-card ad-fold",
      open: openTools,
      onToggle: e => {
        const o = e.currentTarget.open;
        if (o !== openTools) this.setState({
          openTools: o
        });
      }
    }, /*#__PURE__*/React.createElement("summary", null, /*#__PURE__*/React.createElement("b", {
      className: "ad-card-title"
    }, "Connected tools"), /*#__PURE__*/React.createElement("span", {
      className: "ad-muted"
    }, links && links.length ? `${links.length} connected` : "keep a copy of this list in Mailchimp or Constant Contact")), links === undefined ? /*#__PURE__*/React.createElement(Pending, null) : links === null ? /*#__PURE__*/React.createElement(Empty, null, "Connected tools could not be loaded.") : /*#__PURE__*/React.createElement("div", {
      className: "ad-tablewrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "ad-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Tool"), /*#__PURE__*/React.createElement("th", null, "Where"), /*#__PURE__*/React.createElement("th", null, "Direction"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "In Plunk"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "In the tool"), /*#__PURE__*/React.createElement("th", {
      className: "n"
    }, "Waiting to send"), /*#__PURE__*/React.createElement("th", null, "Last update"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, RAILS.map(rail => {
      const l = links.find(x => x.rail === rail);
      if (!l) {
        return /*#__PURE__*/React.createElement("tr", {
          key: rail
        }, /*#__PURE__*/React.createElement("td", {
          className: "ad-name"
        }, RAIL_LABELS[rail]), /*#__PURE__*/React.createElement("td", {
          colSpan: 6,
          className: "ad-muted"
        }, "Not connected"), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", {
          className: "ad-rowact"
        }, /*#__PURE__*/React.createElement("button", {
          className: "territory-toggle",
          onClick: () => this.setState({
            dialog: "link",
            linkRail: rail,
            linkMode: "push",
            linkTarget: "",
            err: ""
          })
        }, "Connect")));
      }
      const st = String(l.status || "").toLowerCase();
      const tone = st === "synced" || st === "ok" ? "success" : st === "error" || st === "failed" ? "danger" : st ? "warning" : "neutral";
      const stLabel = st === "synced" || st === "ok" ? "Up to date" : st === "error" || st === "failed" ? "Needs attention" : st ? st.replace(/_/g, " ") : "Waiting";
      const local = l.localCount != null ? Number(l.localCount) : null;
      const remote = l.providerCount != null ? Number(l.providerCount) : l.remoteCount != null ? Number(l.remoteCount) : null;
      const drift = local != null && remote != null && local !== remote;
      const pending = l.pendingPush != null ? Number(l.pendingPush) : null;
      return /*#__PURE__*/React.createElement("tr", {
        key: rail,
        className: drift ? "ad-drift" : ""
      }, /*#__PURE__*/React.createElement("td", {
        className: "ad-name"
      }, RAIL_LABELS[rail]), /*#__PURE__*/React.createElement("td", null, l.externalListId ? `list ${l.externalListId}` : "new list", l.externalSegmentId ? `, segment ${l.externalSegmentId}` : ""), /*#__PURE__*/React.createElement("td", null, MODE_LABELS[l.syncMode] || String(l.syncMode || "").replace(/_/g, " ")), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, local != null ? num(local) : ""), /*#__PURE__*/React.createElement("td", {
        className: "n",
        title: drift ? `Differs from Plunk by ${num(Math.abs(local - remote))}` : undefined
      }, remote != null ? num(remote) : ""), /*#__PURE__*/React.createElement("td", {
        className: "n"
      }, pending != null ? num(pending) : ""), /*#__PURE__*/React.createElement("td", null, l.lastSynced ? fmtDateTime(l.lastSynced) : "never"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Pill, {
        tone: tone
      }, stLabel), l.lastError ? /*#__PURE__*/React.createElement("div", {
        className: "ad-err-mini",
        title: l.lastError
      }, String(l.lastError).slice(0, 80)) : null), /*#__PURE__*/React.createElement("td", {
        className: "ad-rowact"
      }, unlinking === rail ? /*#__PURE__*/React.createElement(InlineConfirm, {
        variant: "row",
        question: "Disconnect?",
        yes: "Yes, disconnect",
        onYes: () => this.unlink(rail),
        onNo: () => this.setState({
          unlinking: null
        })
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        onClick: () => this.syncNow(rail)
      }, "Update now"), /*#__PURE__*/React.createElement("button", {
        className: "territory-toggle",
        onClick: () => this.setState({
          unlinking: rail
        })
      }, "Disconnect"))));
    })))), /*#__PURE__*/React.createElement("p", {
      className: "ad-small"
    }, "Only people who agreed to get email and are not blocked are sent to a tool. A highlighted row means the tool's count differs from Plunk: press Update now to line them up.", health ? ` ${num(notSent)} of ${num(health.members)} people here are not sent (${num(health.optedOut)} said no to email, ${num(Object.values(health.suppressedByReason || {}).reduce((x, y) => x + Number(y), 0))} blocked).` : ""), /*#__PURE__*/React.createElement("div", {
      className: "ad-actions"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: this.openLink
    }, "Connect a tool"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        dialog: "link",
        linkRail: "mailchimp",
        linkMode: "pull",
        linkTarget: "",
        err: ""
      })
    }, "Bring a list in from a tool")));
  }
  renderHistory(a, st) {
    const {
      trend,
      health,
      summary: s,
      openHistory
    } = this.state;
    const range = this.range();
    return /*#__PURE__*/React.createElement("details", {
      className: "ad-card ad-fold",
      open: openHistory,
      onToggle: e => {
        const o = e.currentTarget.open;
        if (o !== openHistory) this.setState({
          openHistory: o
        });
      }
    }, /*#__PURE__*/React.createElement("summary", null, /*#__PURE__*/React.createElement("b", {
      className: "ad-card-title"
    }, "History"), /*#__PURE__*/React.createElement("span", {
      className: "ad-muted"
    }, "who joined and left, visits by day, email reach")), openHistory ? /*#__PURE__*/React.createElement("div", {
      className: "ad-hist"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ad-hist-block"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ad-h"
    }, "Joined and left, by week"), s === undefined ? /*#__PURE__*/React.createElement(Pending, {
      h: 90
    }) : !s || !(s.growthByWeek || []).length ? /*#__PURE__*/React.createElement("span", {
      className: "ad-small"
    }, "Weekly changes appear once this list has a few weeks of history.") : /*#__PURE__*/React.createElement(GrowthBars, {
      weeks: s.growthByWeek
    })), /*#__PURE__*/React.createElement("div", {
      className: "ad-hist-block"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ad-h"
    }, "Visits by day, ", rangeLabelFor(range, RANGES).toLowerCase()), Array.isArray(trend) && trend.length > 0 ? /*#__PURE__*/React.createElement(AudienceTrendChart, {
      rows: trend,
      series: [{
        name: a.name,
        metric: "sessions",
        label: "Visits"
      }, {
        name: a.name,
        metric: "conversions",
        label: "Conversions"
      }]
    }) : /*#__PURE__*/React.createElement("span", {
      className: "ad-small"
    }, "No day-by-day activity for this period. Try a longer period."), st ? /*#__PURE__*/React.createElement("span", {
      className: "ad-small"
    }, num(st.sessions), " visits by ", num(st.uniqueUsers), " people, ", mmss(st.avgTimeSpan), " on average. ", num(st.engagements), " actions, ", num(st.conversions), " conversions.") : null), /*#__PURE__*/React.createElement("div", {
      className: "ad-hist-block"
    }, /*#__PURE__*/React.createElement("span", {
      className: "ad-h"
    }, "Email reach, last 30 days"), health === undefined ? /*#__PURE__*/React.createElement(Pending, null) : health === null ? /*#__PURE__*/React.createElement("span", {
      className: "ad-small"
    }, "Not available for this list.") : /*#__PURE__*/React.createElement("div", {
      className: "ad-kv"
    }, /*#__PURE__*/React.createElement("span", null, "Can be emailed"), /*#__PURE__*/React.createElement("b", null, num(health.deliverable), " of ", num(health.withEmail)), /*#__PURE__*/React.createElement("span", null, "Opted in"), /*#__PURE__*/React.createElement("b", null, num(health.optedIn)), /*#__PURE__*/React.createElement("span", null, "Allowed from before opt-in records"), /*#__PURE__*/React.createElement("b", null, num(health.legacyAllowed)), /*#__PURE__*/React.createElement("span", null, "Said no to email"), /*#__PURE__*/React.createElement("b", null, num(health.optedOut)), /*#__PURE__*/React.createElement("span", null, "Inactive"), /*#__PURE__*/React.createElement("b", null, num(health.inactive)), /*#__PURE__*/React.createElement("span", null, "Bounced or complained"), /*#__PURE__*/React.createElement("b", null, num(health.bounced), " / ", num(health.complained))))) : null);
  }
  renderImportDialog(a) {
    const {
      importFile,
      importPreview: p,
      applySuggestions,
      importResult: r,
      busy,
      err
    } = this.state;
    const close = this.closeDialog;
    const counts = p ? [["Rows", p.rows], ["New people", p.newPersons], ["Already in your contacts", p.matchedPersons], ["Repeated in the file", p.duplicatesWithinFile], ["Not a valid address", p.invalidSyntax], ["Shared inboxes (info@, sales@)", p.roleAddresses], ["Throwaway addresses", p.disposableDomains], ["Possible typos", p.typoSuggestions], ["Blocked from email", p.suppressed], ["No email permission given", p.noConsent]] : [];
    const typoRows = p ? (p.rowReports || []).filter(x => x.suggestion) : [];
    return /*#__PURE__*/React.createElement(Modal, {
      title: `Upload a file to “${a.name}”`,
      width: 720,
      onClose: close,
      busy: busy,
      note: p && !r ? "Nothing changes until you press Add them." : null,
      footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        onClick: close,
        disabled: busy
      }, r ? "Done" : "Cancel"), !p && !r ? /*#__PURE__*/React.createElement(Button, {
        themeColor: "primary",
        disabled: busy || !importFile,
        onClick: () => this.runImport("preview")
      }, busy ? "Checking…" : "Check the file") : null, p && !r ? /*#__PURE__*/React.createElement(Button, {
        themeColor: "primary",
        disabled: busy,
        onClick: () => this.runImport("commit")
      }, busy ? "Adding…" : "Add them") : null)
    }, r ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Check, {
      m: "ok"
    }, num(r.matchedAdded), " of ", num(r.matchedTotal), " people already in your contacts were added. ", num(r.consentWrites), " email permissions saved", Number(r.consentErrors) ? ` (${num(r.consentErrors)} could not be saved)` : "", "."), /*#__PURE__*/React.createElement(Check, {
      m: Number(r.queuedNew) > 0 ? "warn" : "ok"
    }, num(r.queuedNew), " new people are being added", Number(r.queuedNew) > 0 ? ". They appear here in a few minutes" : "", "."), r.skipped ? /*#__PURE__*/React.createElement(Check, {
      m: "warn"
    }, "Skipped: ", num(r.skipped.invalid), " not valid, ", num(r.skipped.duplicates), " repeated, ", num(r.skipped.suppressed), " blocked from email, ", num(r.skipped.optOutNew), " new people who said no to email.") : null, r.note ? /*#__PURE__*/React.createElement("div", {
      className: "ec-help"
    }, r.note) : null) : !p ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "ec-field"
    }, /*#__PURE__*/React.createElement("label", null, "CSV file"), /*#__PURE__*/React.createElement("input", {
      type: "file",
      accept: ".csv,text/csv",
      onChange: e => this.setState({
        importFile: e.target.files && e.target.files[0],
        err: ""
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "ec-help"
    }, "Include name and email columns. To record email permission, add ", /*#__PURE__*/React.createElement("b", null, "email opt-in"), " (yes, no or blank), ", /*#__PURE__*/React.createElement("b", null, "opt-in date"), " and ", /*#__PURE__*/React.createElement("b", null, "opt-in source"), ". People already in your contacts are added to this list.")), /*#__PURE__*/React.createElement(ErrorLine, null, err)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
      className: "aud-h4"
    }, "What we found ", p.hasConsentColumn ? /*#__PURE__*/React.createElement(Pill, {
      tone: "success"
    }, "email permission column found") : /*#__PURE__*/React.createElement(Pill, {
      tone: "warning"
    }, "no email permission column")), /*#__PURE__*/React.createElement("div", {
      className: "aud-report"
    }, counts.map(([l, v]) => /*#__PURE__*/React.createElement("div", {
      className: "aud-f",
      key: l
    }, /*#__PURE__*/React.createElement("span", null, l), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, num(v))))), p.unknownHeaders && p.unknownHeaders.length ? /*#__PURE__*/React.createElement("div", {
      className: "ec-help"
    }, "Columns we skip: ", p.unknownHeaders.join(", ")) : null, typoRows.length ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
      className: "aud-h4"
    }, "Possible typos"), /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table aud-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Line"), /*#__PURE__*/React.createElement("th", null, "Address"), /*#__PURE__*/React.createElement("th", null, "Did you mean"))), /*#__PURE__*/React.createElement("tbody", null, typoRows.slice(0, 25).map(x => /*#__PURE__*/React.createElement("tr", {
      key: x.line
    }, /*#__PURE__*/React.createElement("td", null, x.line), /*#__PURE__*/React.createElement("td", {
      className: "aud-email"
    }, x.email), /*#__PURE__*/React.createElement("td", {
      className: "aud-email"
    }, x.suggestion)))))), typoRows.length > 25 ? /*#__PURE__*/React.createElement("div", {
      className: "ec-help"
    }, "and ", num(typoRows.length - 25), " more") : null, /*#__PURE__*/React.createElement("label", {
      className: "ec-check"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      checked: applySuggestions,
      onChange: e => this.setState({
        applySuggestions: e.target.checked
      })
    }), /*#__PURE__*/React.createElement("span", null, "Fix the ", num(p.typoSuggestions), " possible typos when adding"))) : null, /*#__PURE__*/React.createElement(ErrorLine, null, err)));
  }
  renderDialogs(a, all) {
    const {
      dialog,
      busy,
      err,
      addText,
      fromListId,
      fromListMode,
      ruleTree,
      rulePreview,
      targetId,
      snapName,
      linkRail,
      linkMode,
      linkTarget
    } = this.state;
    const close = this.closeDialog;
    const nSel = Object.keys(this.state.selected).length;
    const otherLists = (all || []).filter(l => String(l.id) !== this.id() && l.kind !== "system" && !SYSTEM_NAMES.includes(l.name));
    const targets = otherLists.filter(l => l.kind !== "dynamic");
    const listOptions = ls => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, "Choose a list\u2026"), ls.map(l => /*#__PURE__*/React.createElement("option", {
      key: String(l.id),
      value: String(l.id)
    }, l.name, l.total != null ? ` (${num(l.total)})` : "")));
    switch (dialog) {
      case "email":
        return /*#__PURE__*/React.createElement(Modal, {
          title: "Paste email addresses",
          width: 560,
          onClose: close,
          busy: busy,
          note: "People already in your contacts are added. Addresses we don't know are listed, not created (upload a file to add new people).",
          footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            onClick: close,
            disabled: busy
          }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
            themeColor: "primary",
            disabled: busy,
            onClick: this.addByEmails
          }, busy ? "Adding…" : "Add"))
        }, /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "Addresses"), /*#__PURE__*/React.createElement("textarea", {
          className: "ec-input",
          rows: 6,
          autoFocus: true,
          value: addText,
          onChange: e => this.setState({
            addText: e.target.value
          }),
          placeholder: "name@example.com"
        }), /*#__PURE__*/React.createElement("div", {
          className: "ec-help"
        }, "One per line, or separated by commas.")), /*#__PURE__*/React.createElement(ErrorLine, null, err));
      case "import":
        return this.renderImportDialog(a);
      case "fromList":
        return /*#__PURE__*/React.createElement(Modal, {
          title: `Copy people from another list into “${a.name}”`,
          width: 560,
          onClose: close,
          busy: busy,
          note: "People blocked from email and people without an address are skipped.",
          footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            onClick: close,
            disabled: busy
          }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
            themeColor: "primary",
            disabled: busy || !fromListId,
            onClick: this.addFromList
          }, busy ? "Adding…" : "Add"))
        }, /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "Copy from"), /*#__PURE__*/React.createElement("select", {
          className: "ec-input",
          autoFocus: true,
          value: fromListId,
          onChange: e => this.setState({
            fromListId: e.target.value
          })
        }, listOptions(otherLists))), /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "Who to add"), /*#__PURE__*/React.createElement("label", {
          className: "ec-check"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          name: "from-mode",
          checked: fromListMode === "not_in_target",
          onChange: () => this.setState({
            fromListMode: "not_in_target"
          })
        }), /*#__PURE__*/React.createElement("span", null, "Only people who are not here yet")), /*#__PURE__*/React.createElement("label", {
          className: "ec-check"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          name: "from-mode",
          checked: fromListMode === "all",
          onChange: () => this.setState({
            fromListMode: "all"
          })
        }), /*#__PURE__*/React.createElement("span", null, "Everyone in that list (people already here are kept)"))), /*#__PURE__*/React.createElement(ErrorLine, null, err));
      case "fromRule":
        return /*#__PURE__*/React.createElement(Modal, {
          title: `Pick people with a filter for “${a.name}”`,
          width: 960,
          onClose: close,
          busy: busy,
          note: "The count shows who matches today and how many are new to this list. They are added once; the list does not keep updating.",
          footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            onClick: close,
            disabled: busy
          }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
            themeColor: "primary",
            disabled: busy || !rulePreview || !Number(rulePreview.wouldAdd),
            onClick: this.addFromRule
          }, busy ? "Adding…" : rulePreview && rulePreview.wouldAdd != null ? `Add ${num(rulePreview.wouldAdd)}` : "Add"))
        }, /*#__PURE__*/React.createElement(RuleBuilder, {
          value: ruleTree,
          onChange: t => this.setState({
            ruleTree: t
          }),
          lists: otherLists,
          estimator: this.previewRule,
          onEstimate: p => this.setState({
            rulePreview: p
          })
        }), /*#__PURE__*/React.createElement(ErrorLine, null, err));
      case "copy":
      case "move":
        {
          const move = dialog === "move";
          return /*#__PURE__*/React.createElement(Modal, {
            title: `${move ? "Move" : "Copy"} ${num(nSel)} ${nSel === 1 ? "person" : "people"} to a list`,
            width: 520,
            onClose: close,
            busy: busy,
            note: move ? "They leave this list and join the other one." : "They stay here and also join the other list.",
            footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
              onClick: close,
              disabled: busy
            }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
              themeColor: "primary",
              disabled: busy || !targetId,
              onClick: () => this.bulk(dialog)
            }, busy ? move ? "Moving…" : "Copying…" : move ? "Move" : "Copy"))
          }, /*#__PURE__*/React.createElement("div", {
            className: "ec-field"
          }, /*#__PURE__*/React.createElement("label", null, "List"), /*#__PURE__*/React.createElement("select", {
            className: "ec-input",
            autoFocus: true,
            value: targetId,
            onChange: e => this.setState({
              targetId: e.target.value
            })
          }, listOptions(targets)), /*#__PURE__*/React.createElement("div", {
            className: "ec-help"
          }, "Only lists you add people to. Lists that fill themselves choose their own people.")), /*#__PURE__*/React.createElement(ErrorLine, null, err));
        }
      case "snapshot":
        return /*#__PURE__*/React.createElement(Modal, {
          title: "Make a copy",
          width: 520,
          onClose: close,
          busy: busy,
          note: "Copies today's people into a new list you add people to by hand. This list stays as it is.",
          footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            onClick: close,
            disabled: busy
          }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
            themeColor: "primary",
            disabled: busy,
            onClick: this.snapshot
          }, busy ? "Copying…" : "Make a copy"))
        }, /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "Name"), /*#__PURE__*/React.createElement("input", {
          autoFocus: true,
          value: snapName,
          onChange: e => this.setState({
            snapName: e.target.value
          })
        })), /*#__PURE__*/React.createElement(ErrorLine, null, err));
      case "remove":
        return /*#__PURE__*/React.createElement(Modal, {
          title: `Remove “${a.name}”?`,
          width: 480,
          onClose: close,
          busy: busy,
          note: "The list goes away. The people in it stay in your contacts.",
          footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            onClick: close,
            disabled: busy
          }, "Keep"), /*#__PURE__*/React.createElement(Button, {
            themeColor: "primary",
            disabled: busy,
            onClick: this.removeList
          }, busy ? "Removing…" : "Yes, remove"))
        }, /*#__PURE__*/React.createElement("p", {
          className: "ec-help"
        }, "Emails, ads and connected tools that use this list stop getting updates from it."), /*#__PURE__*/React.createElement(ErrorLine, null, err));
      case "link":
        return /*#__PURE__*/React.createElement(Modal, {
          title: linkMode === "pull" ? "Bring a list in from a tool" : "Keep a copy in another tool",
          width: 560,
          onClose: close,
          busy: busy,
          note: "Connect the tool first under Email, Settings.",
          footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
            onClick: close,
            disabled: busy
          }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
            themeColor: "primary",
            disabled: busy,
            onClick: this.saveLink
          }, busy ? "Connecting…" : "Connect"))
        }, /*#__PURE__*/React.createElement("div", {
          className: "ec-grid-2"
        }, /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "Tool"), /*#__PURE__*/React.createElement("select", {
          className: "ec-input",
          value: linkRail,
          onChange: e => this.setState({
            linkRail: e.target.value
          })
        }, RAILS.map(r => /*#__PURE__*/React.createElement("option", {
          key: r,
          value: r
        }, RAIL_LABELS[r])))), /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "Direction"), /*#__PURE__*/React.createElement("select", {
          className: "ec-input",
          value: linkMode,
          onChange: e => this.setState({
            linkMode: e.target.value
          })
        }, Object.entries(MODE_LABELS).map(([v, l]) => /*#__PURE__*/React.createElement("option", {
          key: v,
          value: v
        }, l))))), /*#__PURE__*/React.createElement("div", {
          className: "ec-field"
        }, /*#__PURE__*/React.createElement("label", null, "List id in the tool (optional)"), /*#__PURE__*/React.createElement("input", {
          value: linkTarget,
          onChange: e => this.setState({
            linkTarget: e.target.value
          }),
          placeholder: "for example a Mailchimp audience id"
        }), /*#__PURE__*/React.createElement("div", {
          className: "ec-help"
        }, "Leave it blank and we create a new list there. Only people who agreed to get email and are not blocked are sent. Bringing a list in adds its people here with their email permission.")), /*#__PURE__*/React.createElement(ErrorLine, null, err));
      case "edit":
        return /*#__PURE__*/React.createElement(ListEditor, {
          audience: a,
          lists: all,
          onClose: close,
          onSaved: () => {
            close();
            toast("Saved.");
            this.load();
          },
          onSnapshot: r => {
            if (r && r.id !== undefined) this.props.history.push(`/Audiences/Detail/${encodeURIComponent(String(r.id))}/${this.range()}`);
          }
        });
      case "convert":
        return /*#__PURE__*/React.createElement(ListEditor, {
          audience: a,
          lists: all,
          mode: "convert",
          onClose: close,
          onSaved: () => {
            close();
            toast(`“${a.name}” now fills itself.`);
            this.load();
          }
        });
      default:
        return null;
    }
  }
  render() {
    const {
      data,
      error,
      note,
      summary: s,
      members,
      memberCount
    } = this.state;
    if (error) return /*#__PURE__*/React.createElement(Error, null);
    if (!data) return /*#__PURE__*/React.createElement(Loader, null);
    const {
      a,
      stats,
      sl,
      all
    } = data;
    if (!a) {
      return /*#__PURE__*/React.createElement(CssContainer, {
        cls: "margin-squeeze"
      }, /*#__PURE__*/React.createElement("p", {
        className: "module-empty"
      }, "This list no longer exists. ", /*#__PURE__*/React.createElement(Link, {
        to: "/Audiences"
      }, "Back to Audiences")));
    }
    const isProtected = SYSTEM_NAMES.includes(a.name) || a.kind === "system";
    const isDynamic = a.kind === "dynamic";
    const st = stats && stats.id !== undefined ? stats : null;
    const count = s && s.members != null ? s.members : members ? memberCount : a.total;
    return /*#__PURE__*/React.createElement("div", {
      className: "aud-mgmt ad-page"
    }, this.renderHeader(a, isProtected, isDynamic, count), note ? /*#__PURE__*/React.createElement(Banner, {
      onClose: () => this.setState({
        note: ""
      })
    }, note) : null, /*#__PURE__*/React.createElement("div", {
      className: "ad-grid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ad-main"
    }, this.renderPeople(a, isDynamic, isProtected), this.renderTools(), this.renderHistory(a, st)), /*#__PURE__*/React.createElement("aside", {
      className: "ad-side"
    }, this.renderHowCard(a, isDynamic, isProtected), this.renderNumbersCard(st, sl), this.renderUseCard(a))), this.renderDialogs(a, all));
  }
}
export default withRouter(AudienceDetailViewComponent);